const $ = jQuery;

const LoginRegisterToggle = {
  init: function () {
    const loginForm = $('#customer_login .u-column1');
    const registerForm = $('#customer_login .u-column2');
    const toggleRegisterButton = $('#show-register');
    const toggleLoginButton = $('#show-login');


    if (loginForm.length && registerForm.length) {
      loginForm.addClass('active'); 

      toggleRegisterButton.on('click', () => {
        loginForm.removeClass('active');
        registerForm.addClass('active');
        $('.toggle-register').hide();
        $('.toggle-login').show();
      });

      toggleLoginButton.on('click', () => {
        registerForm.removeClass('active');
        loginForm.addClass('active');
        $('.toggle-register').show();
        $('.toggle-login').hide();
      });
    }
  },
};

export default LoginRegisterToggle;
